<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header d-flex justify-content-between align-items-center">
        <div>
          <h3 class="page-title">
            <i class="fa fa-money mr-2 text-primary"></i>
            Duyệt tạm ứng lương
          </h3>
          <div class="text-muted small">NV bấm nút, admin bấm duyệt. Con người được đơn giản hóa.</div>
        </div>
        <button class="btn btn-outline-secondary" @click="load" :disabled="st.admin.loading">
          <i class="fa fa-refresh mr-1"></i> Tải
        </button>
      </div>

      <!-- FILTER -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row small">
            <div class="col-md-2 mb-2">
              <label class="text-muted">Từ</label>
              <input type="date" class="form-control form-control-sm" v-model="st.admin.filters.from" />
            </div>
            <div class="col-md-2 mb-2">
              <label class="text-muted">Đến</label>
              <input type="date" class="form-control form-control-sm" v-model="st.admin.filters.to" />
            </div>
            <div class="col-md-2 mb-2">
              <label class="text-muted">Trạng thái</label>
              <select class="form-control form-control-sm" v-model="st.admin.filters.status">
                <option value="ALL">Tất cả</option>
                <option value="PENDING">PENDING</option>
                <option value="APPROVED">APPROVED</option>
                <option value="REJECTED">REJECTED</option>
                <option value="CANCELLED">CANCELLED</option>
              </select>
            </div>
            <div class="col-md-3 mb-2">
              <label class="text-muted">Từ khoá</label>
              <input class="form-control form-control-sm" v-model.trim="st.admin.filters.keyword" placeholder="Tên / ghi chú..." />
            </div>
            <div class="col-md-3 mb-2 d-flex align-items-end">
              <button class="btn btn-sm btn-primary w-100" @click="apply">
                <i class="fa fa-filter mr-1"></i> Lọc
              </button>
            </div>
          </div>
          <div v-if="st.admin.error" class="alert alert-danger mt-2 mb-0">{{ st.admin.error }}</div>
        </div>
      </div>

      <!-- LIST -->
      <div class="card">
        <div class="card-body">
          <div v-if="st.admin.loading" class="text-muted">Đang tải…</div>
          <div v-else-if="!st.admin.list.length" class="text-muted">Không có dữ liệu.</div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-sm mb-0">
              <thead class="thead-light">
                <tr>
                  <th style="min-width:120px;">Ngày</th>
                  <th style="min-width:200px;">Nhân viên</th>
                  <th class="text-right" style="min-width:140px;">Số tiền</th>
                  <th style="min-width:120px;">Trạng thái</th>
                  <th>Ghi chú</th>
                  <th style="min-width:240px;">Tác vụ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="it in st.admin.list" :key="it.id">
                  <td>{{ dt(it.createdAt || it.ngayTao) }}</td>
                  <td>
                    <div class="font-weight-bold">{{ it.hoTen || it.nguoiDungHoTen || ("#" + it.userId) }}</div>
                    <div class="small text-muted">ID: {{ it.userId || it.idNguoiDung }}</div>
                  </td>
                  <td class="text-right font-weight-bold">{{ money(it.soTien) }}</td>
                  <td>
                    <span class="badge" :class="badge(it.trangThai)">{{ it.trangThai }}</span>
                  </td>
                  <td class="text-muted">{{ it.ghiChu || "—" }}</td>
                  <td>
                    <div class="d-flex flex-wrap gap-2">
                      <button
                        class="btn btn-sm btn-success"
                        :disabled="st.admin.acting || it.trangThai !== 'PENDING'"
                        @click="approve(it)"
                      >
                        <i class="fa fa-check mr-1"></i> Duyệt
                      </button>

                      <button
                        class="btn btn-sm btn-outline-danger"
                        :disabled="st.admin.acting || it.trangThai !== 'PENDING'"
                        @click="openReject(it)"
                      >
                        <i class="fa fa-times mr-1"></i> Từ chối
                      </button>

                      <label class="btn btn-sm btn-outline-primary mb-0" :class="{ disabled: st.admin.acting || it.trangThai !== 'APPROVED' }">
                        <i class="fa fa-upload mr-1"></i> Ảnh CK
                        <input
                          type="file"
                          accept="image/*"
                          class="d-none"
                          :disabled="st.admin.acting || it.trangThai !== 'APPROVED'"
                          @change="onPickProof(it, $event)"
                        />
                      </label>

                      <a v-if="it.proofUrl || it.anhChuyenTienUrl" class="btn btn-sm btn-outline-secondary" :href="(it.proofUrl || it.anhChuyenTienUrl)" target="_blank">
                        <i class="fa fa-image mr-1"></i> Xem ảnh
                      </a>
                    </div>

                    <div class="small text-muted mt-1" v-if="it.ghiChuAdmin">
                      Admin: {{ it.ghiChuAdmin }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- PAGER -->
          <div class="d-flex align-items-center justify-content-between mt-2" v-if="st.admin.page.totalPages > 1">
            <small class="text-muted">
              Trang {{ st.admin.page.number + 1 }}/{{ st.admin.page.totalPages }} • {{ st.admin.page.totalElements }} dòng
            </small>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-outline-secondary" :disabled="st.admin.page.number === 0" @click="st.changeAdminPage(st.admin.page.number-1)">‹</button>
              <button class="btn btn-outline-secondary" :disabled="st.admin.page.number >= st.admin.page.totalPages-1" @click="st.changeAdminPage(st.admin.page.number+1)">›</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Reject modal -->
    <div v-if="rejectModal.open">
      <div class="modal custom-modal fade show" style="display:block;" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:520px;">
          <div class="modal-content">
            <div class="modal-header border-0">
              <h5 class="modal-title">Từ chối tạm ứng</h5>
              <button type="button" class="close" @click="closeReject"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="small text-muted mb-2">
                Đơn #{{ rejectModal.item?.id }} • {{ rejectModal.item?.hoTen || rejectModal.item?.nguoiDungHoTen || 'NV' }} • {{ money(rejectModal.item?.soTien) }}
              </div>
              <label class="small mb-1">Lý do</label>
              <textarea class="form-control" rows="3" v-model.trim="rejectModal.reason" placeholder="Nhập lý do từ chối..."></textarea>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-secondary" @click="closeReject">Huỷ</button>
              <button class="btn btn-danger" :disabled="st.admin.acting" @click="doReject">
                <i class="fa fa-times mr-1"></i> Từ chối
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>
  </div>
</template>

<script>
import { useTamUngLuongStore } from "@/stores/tamUngLuongStore";

export default {
  name: "TamUngLuongAdmin",
  data() {
    return {
      rejectModal: {
        open: false,
        item: null,
        reason: "",
      },
    };
  },
  computed: {
    st() {
      return useTamUngLuongStore();
    },
  },
  methods: {
    async load() {
      await this.st.loadAdmin({ page: 0 });
    },
    async apply() {
      this.st.admin.page.number = 0;
      await this.st.loadAdmin();
    },
    badge(st) {
      const s = (st || "").toUpperCase();
      if (s === "APPROVED") return "badge-success";
      if (s === "REJECTED") return "badge-danger";
      if (s === "CANCELLED") return "badge-secondary";
      return "badge-warning";
    },
    money(v) {
      const n = Number(v || 0);
      return n.toLocaleString("vi-VN") + " đ";
    },
    dt(s) {
      if (!s) return "—";
      return String(s).replace("T", " ").slice(0, 16);
    },
    async approve(it) {
      await this.st.approve(it.id, "");
    },
    openReject(it) {
      this.rejectModal.open = true;
      this.rejectModal.item = it;
      this.rejectModal.reason = "";
    },
    closeReject() {
      this.rejectModal.open = false;
      this.rejectModal.item = null;
      this.rejectModal.reason = "";
    },
    async doReject() {
      const it = this.rejectModal.item;
      if (!it) return;
      await this.st.reject(it.id, this.rejectModal.reason || "");
      this.closeReject();
    },
    async onPickProof(it, ev) {
      const file = ev?.target?.files?.[0];
      if (!file) return;
      await this.st.uploadProof(it.id, file);
      ev.target.value = "";
    },
  },
  async mounted() {
    await this.load();
  },
};
</script>

<style scoped>
.gap-2 { gap: 8px; }
</style>
